var _classCallCheck = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Transform = require("stream").Transform;

var UploadStream = /*#__PURE__*/function (_Transform) {
  "use strict";

  _inherits(UploadStream, _Transform);

  function UploadStream(options) {
    var _this;

    _classCallCheck(this, UploadStream);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UploadStream).call(this));
    _this.boundary = options.boundary;
    return _this;
  }

  _createClass(UploadStream, [{
    key: "_transform",
    value: function _transform(data, encoding, next) {
      var buffer = Buffer.isBuffer(data) ? data : Buffer.from(data, encoding);
      this.push(buffer);
      next();
    }
  }, {
    key: "_flush",
    value: function _flush(next) {
      this.push(Buffer.from("\r\n", 'ascii'));
      this.push(Buffer.from("--" + this.boundary + "--", 'ascii'));
      return next();
    }
  }]);

  return UploadStream;
}(Transform);

module.exports = UploadStream;